import {
  ACTION_GET_ORG_EXPENSES,
  ACTION_GET_ORG_EXPENSES_SUCCESS,
  ACTION_GET_ORG_EXPENSES_FAILURE,
  ACTION_GET_MORE_ORG_EXPENSES,
  ACTION_GET_MORE_ORG_EXPENSES_SUCCESS,
  ACTION_GET_MORE_ORG_EXPENSES_FAILURE,
  ACTION_EMPTY_ORG_EXPENSES,
  ACTION_EDIT_EXPENSE,
  ACTION_EDIT_EXPENSE_SUCCESS,
  ACTION_EDIT_EXPENSE_FAILURE,
} from '../configs/ActionTypes';

import { Expense, Cursor } from '../components/CompanyDetails/expenseTypes';

export type OrgExpensesState = {
  expenses: Expense[];
  isLoading: boolean;
  isLoadingMore: boolean;
  hasMore: boolean;
  cursor: Cursor | null;
  success: boolean | null;
};

const initialState: OrgExpensesState = {
  expenses: [],
  isLoading: false,
  isLoadingMore: false,
  hasMore: true,
  cursor: null,
  success: null,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case ACTION_GET_ORG_EXPENSES: {
      return { ...state, isLoading: true, success: null };
    }

    case ACTION_GET_ORG_EXPENSES_SUCCESS: {
      const { data, cursor } = action.payload?.payload ?? {};
      const resolvedCursor = cursor ?? null;
      return {
        ...state,
        isLoading: false,
        expenses: data || [],
        cursor: resolvedCursor,
        hasMore: resolvedCursor !== null,
        success: null,
      };
    }

    case ACTION_GET_ORG_EXPENSES_FAILURE: {
      return { ...state, isLoading: false, success: false };
    }

    case ACTION_GET_MORE_ORG_EXPENSES: {
      return { ...state, isLoadingMore: true };
    }

    case ACTION_GET_MORE_ORG_EXPENSES_SUCCESS: {
      const { data, cursor } = action.payload?.payload ?? {};
      const resolvedCursor = cursor ?? null;
      return {
        ...state,
        isLoadingMore: false,
        expenses: [...state.expenses, ...(data || [])],
        cursor: resolvedCursor,
        hasMore: resolvedCursor !== null,
      };
    }

    case ACTION_GET_MORE_ORG_EXPENSES_FAILURE: {
      return { ...state, isLoadingMore: false };
    }

    case ACTION_EDIT_EXPENSE: {
      return { ...state, isLoading: true, success: null };
    }

    case ACTION_EDIT_EXPENSE_SUCCESS: {
      const updatedExpenses: Expense[] = action.payload?.payload ?? [];
      const updatedMap = new Map(
        updatedExpenses.map((e) => [e.id, e]),
      );
      const expenses = updatedMap.size > 0
        ? state.expenses.map((e) =>
            updatedMap.has(e.id) ? { ...e, ...updatedMap.get(e.id) } : e,
          )
        : state.expenses;

      return {
        ...state,
        expenses,
        isLoading: false,
        success: true,
      };
    }

    case ACTION_EDIT_EXPENSE_FAILURE: {
      return { ...state, isLoading: false, success: false };
    }

    case ACTION_EMPTY_ORG_EXPENSES: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
